module.exports = __webpack_public_path__ + "media/images/product_lines/motorcycle/main_m-dda3b0b87e83f099a32a4268d6c8d7ec.svg";